import request from "@utils/request";

/**
 * @author FJJ
 * @version 1.0 
 *
 **/
const ModalConfirmPaymentAction = {
    /**
     * 获取单个出库详情
     * @param data
     */
    post(sUrl,data={}) {
        return request({
            url: sUrl,
            method: "POST",
            data
        });
    },
};

export default ModalConfirmPaymentAction;
